import { Utils } from './utils';
export var EventKeyModifier;
(function (EventKeyModifier) {
    EventKeyModifier["AltKey"] = "Alt";
    EventKeyModifier["CtrlKey"] = "Ctrl";
    EventKeyModifier["ShiftKey"] = "Shift";
    EventKeyModifier["MetaKey"] = "Cmd";
})(EventKeyModifier || (EventKeyModifier = {}));
export class CustomEventUtils {
    static isInstanceOf(evt, type) {
        return evt instanceof type;
        // || CustomElementUtils.getAttachedPropertyValue(evt, 'pacem:custom-event') === evt.type;
    }
    static getEventCoordinates(evt) {
        var src;
        if ('touches' in evt) {
            if (!Utils.isNullOrEmpty(evt.touches)) {
                src = evt.touches[0];
            }
            else if (!Utils.isNullOrEmpty(evt.changedTouches)) {
                src = evt.changedTouches[0];
            }
        }
        else {
            src = evt;
        }
        return {
            page: { x: src.pageX, y: src.pageY },
            screen: { x: src.screenX, y: src.screenY },
            client: { x: src.clientX, y: src.clientY }
        };
    }
    static getEventKeyModifiers(evt) {
        var which = evt.which;
        if (evt instanceof MouseEvent) {
            which = evt.button;
        }
        return {
            which: which, shiftKey: evt.shiftKey, altKey: evt.altKey, ctrlKey: evt.ctrlKey, metaKey: evt.metaKey
        };
    }
    static matchModifiers(evt, ...args) {
        const modifiers = !Utils.isNull(args) && (args.length === 1 && Utils.isArray(args[0]) ? args[0] : Array.from(args).filter(i => !Utils.isNullOrEmpty(i))), lowerCaseModifiers = (modifiers || []).map(i => i.toLowerCase());
        const altKey = lowerCaseModifiers.indexOf('alt') >= 0 || lowerCaseModifiers.indexOf('option') >= 0, shiftKey = lowerCaseModifiers.indexOf('shift') >= 0, ctrlKey = lowerCaseModifiers.indexOf('ctrl') >= 0, metaKey = lowerCaseModifiers.indexOf('win') >= 0 || lowerCaseModifiers.indexOf('cmd') >= 0;
        if (altKey !== evt.altKey
            || shiftKey !== evt.shiftKey
            || metaKey !== evt.metaKey
            || ctrlKey !== evt.ctrlKey) {
            return false;
        }
        return true;
    }
    static fixEdgeCustomEventSubClassInstance(evt, type) {
        // this an optimistic BUGGED workaround due to a damn' Edge bug: https://github.com/Microsoft/ChakraCore/issues/3952
        if (!(evt instanceof type)) {
            Object.setPrototypeOf(evt, type);
        }
    }
}
//}
